import { createElementBlock as t, openBlock as o, createElementVNode as r } from "vue";
import l from "./index289.js";
const n = {}, c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(a, e, p, m, i, f) {
  return o(), t("svg", c, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      d: "M12 2.25a9.75 9.75 0 1 1 0 19.5 9.75 9.75 0 0 1 0-19.5Zm0 1.5a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5Zm3.524 5.713a.75.75 0 0 1 .084.976l-.071.085-4.714 4.827-.018.035c-.22.349-.71.535-1.109.206l-.097-.091-2.135-2.183a.75.75 0 0 1-.062-.978l.074-.083a.75.75 0 0 1 .977-.062l.083.074 1.602 1.637 4.325-4.43a.75.75 0 0 1 1.06-.013Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ l(n, [["render", s]]);
export {
  u as default
};
